module.exports = __webpack_public_path__ + "img/icon2.e9202d0c.40fdb6b4.png";